import { get } from '../client';

export const dashboardApi = {
  getCounts: () => get('/dashboard'),
  villageSummary: (params = {}) => get('/dashboard/village-summary', { params }),
  buSiteSummary: (params = {}) => get('/dashboard/bu-site-summary', { params }),
};
